/**
 * Comment photo URLs (2026-11-01 review). A comment's imageUrls are written by
 * one member and rendered in the OTHER member's browser as a clickable link
 * and an <img>. firestore.rules now rejects anything that is not a download
 * URL from our own bucket (isApprovedPhotoUrl there), but records written
 * before that rule, or by a path the rule does not cover, must still never
 * become an unsafe link. So every render site filters through this first.
 *
 * Mirrors the rule: exact host, exact bucket, the folder the feature uploads
 * to, a single encoded object name, and the download query. Keep the two in
 * step; src/utils/__tests__/photoUrl.test.js pins the cases.
 */
export const PHOTO_BUCKET = 'pedalxchange.firebasestorage.app';

const COMMENT_PHOTO_FOLDERS = ['offer_message_photos', 'match_message_photos', 'trade_message_photos'];

const pattern = (folders) => new RegExp(
  '^https://firebasestorage\\.googleapis\\.com/v0/b/' +
  PHOTO_BUCKET.replace(/\./g, '\\.') +
  '/o/(' + folders.join('|') + ')%2F[A-Za-z0-9_%.-]+\\?alt=media(&token=[A-Za-z0-9-]+)?$'
);

const COMMENT_PHOTO_RE = pattern(COMMENT_PHOTO_FOLDERS);

/** True only for a download URL of one of our comment-photo folders. */
export function isApprovedCommentPhotoUrl(url) {
  return typeof url === 'string' && COMMENT_PHOTO_RE.test(url);
}

/** The subset of `urls` that is safe to render as links and images. */
export function safeCommentPhotoUrls(urls) {
  return Array.isArray(urls) ? urls.filter(isApprovedCommentPhotoUrl) : [];
}
